import { createFileRoute, redirect } from '@tanstack/react-router'

import { AppLayout } from '@/components/layouts/app/layout'

import { useAuth } from '@/libs/hooks/use-auth'

export const Route = createFileRoute('/_app')({
	beforeLoad: async ({ preload, context }) => {
		if (preload) return null

		const { isAuthenticated } = useAuth.getState()
		if (!isAuthenticated) {
			throw redirect({
				to: '/auth/login',
				search: { redirectTo: location.pathname },
				replace: true,
			})
		}

		const { qc } = context
		const outletId = useAuth.getState().outlet?.outletId

		await Promise.all([
			// outletId ? qc.ensureQueryData(salesTypeList.qry({ outletId })) : null,
		])
	},
	component: AppLayout,
})
